import React, { useEffect } from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

function TermsOfService() {
  const [ref, isVisible] = useScrollAnimation(0.1);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className={`terms-of-service fade-in-up ${isVisible ? 'visible' : ''}`} ref={ref}>
      <div className="container">
        <h1>תקנון השימוש באפליקציית Reado</h1>
        <p className="update-date">עודכן לאחרונה בתאריך: 02/06/2026</p>

        <div className="terms-content">
          <section>
            <h2>1. כללי והגדרות</h2>
            <p>1.1. תקנון זה מסדיר את התנאים החלים על שימוש באפליקציית Reado (להלן: "האפליקציה" או "השירות"), המופעלת על ידי רז קליין, עוסק פטור מס' 212609481, שכתובתו רחוב קוממיות 9, מגדל העמק (להלן: "המפעיל").</p>
            <p>1.2. כל שימוש באפליקציה מהווה הסכמה לתנאים המפורטים בתקנון זה. משתמש שאינו מסכים לתנאים אלה מתבקש שלא לעשות שימוש בשירות.</p>
            <p>1.3. "משתמש" – כל אדם המשתמש באפליקציה, בין אם נרשם ובין אם לאו.</p>
            <p>1.4. "מנוי" – משתמש אשר רכש גישה לשירותים המלאים באפליקציה בתשלום חודשי או שנתי.</p>
          </section>

          <section>
            <h2>2. תיאור השירות</h2>
            <p>2.1. האפליקציה מספקת למשתמשים פלטפורמת למידה אישית הכוללת:</p>
            <ul>
              <li>סיכומי טקסט של ספרי התפתחות אישית.</li>
              <li>סיכומי אודיו מוקלטים.</li>
              <li>שאלונים אינטראקטיביים להטמעת הידע.</li>
              <li>כלים לכתיבת משימות יישומיות (כולל סיוע חלקי מבוסס AI).</li>
            </ul>
            <p>2.2. השירות כולל גרסה חינמית מוגבלת, וגרסת מנוי בתשלום הכוללת את כל האפשרויות.</p>
            <p>2.3. חלק מהתכנים מותאמים ברמה גנרית בלבד; אין באפליקציה ייעוץ אישי, טיפולי או מקצועי מכל סוג שהוא.</p>
            <p>2.4. חלק מהתכנים והכלים באפליקציה עושים שימוש בבינה מלאכותית (AI). תכנים אלה עשויים להיות לא מדויקים, מוטים, חסרים או שגויים, והמשתמש מתבקש לאמת מידע חיוני באופן עצמאי. השירות אינו מהווה ייעוץ פסיכולוגי, רפואי, פיננסי, משפטי או מקצועי אחר, ואין להסתמך עליו כתחליף לייעוץ כאמור.</p>
          </section>

          <section>
            <h2>3. הרשמה לשירות ויצירת חשבון</h2>
            <p>3.1. ניתן להשתמש באפליקציה מגיל 13 ומעלה בלבד.</p>
            <p>3.2. לצורך שימוש מלא בשירות, על המשתמש להירשם ולספק פרטים אישיים כגון שם, כתובת מייל ופרטים נוספים שיידרשו בעת ההרשמה.</p>
            <p>3.3. המשתמש אחראי לשמירה על סודיות פרטי ההתחברות שלו.</p>
            <p>3.4. משתמשים מתחת לגיל 18 נדרשים לקבל את הסכמת הורה או אפוטרופוס לפני השימוש בשירות. המפעיל אינו אוסף ביודעין מידע ממשתמשים מתחת לגיל 13; אם נודע למפעיל כי נאסף מידע כזה, המידע יימחק בהקדם האפשרי.</p>
          </section>

          <section>
            <h2>4. מדיניות תשלום ומנויים</h2>
            <p>4.1. השירות מוצע בשתי תוכניות מנוי:</p>
            <ul>
              <li>מנוי חודשי בעלות של 47 ש"ח לחודש, מתחדש באופן אוטומטי כל חודש.</li>
              <li>מנוי שנתי בעלות של 424.90 ש"ח לשנה, מתחדש באופן אוטומטי כל שנה (חיסכון של כ-25% לעומת תשלום חודשי).</li>
            </ul>
            <p>4.2. למשתמשים חדשים מוצעת תקופת ניסיון חינם בת 7 ימים. החיוב הראשון יתבצע בתום תקופת הניסיון, אלא אם בוטל המנוי קודם לכן.</p>
            <p>4.3. הרכישה והחיוב מתבצעים דרך חשבון ה-Apple ID של המשתמש באמצעות חנות האפליקציות של אפל (App Store), או דרך חשבון Google של המשתמש באמצעות חנות Google Play. המפעיל אינו צד לעסקת הסליקה ואינו שומר פרטי אמצעי תשלום.</p>
            <p>4.4. המשתמש רשאי לבטל את המנוי בכל עת דרך הגדרות החשבון במכשירו (Settings → Apple ID → Subscriptions במכשירי iOS, או Google Play → Payments & subscriptions במכשירי Android), בכפוף להוראות חוק הגנת הצרכן, התשמ"א-1981.</p>
            <p>4.5. ביטול מנוי בתקופת הניסיון לפני סיומה לא יחויב כלל. ביטול לאחר תחילת תקופת חיוב יותיר את הגישה פעילה עד תום התקופה ששולמה ולא יחויב מחדש.</p>
            <p>4.6. לא יינתנו החזרים רטרואקטיביים עבור תקופות שימוש שכבר חלפו, אלא אם נדרש אחרת על פי דין. בקשות החזר עבור חיובים שגויים יש להפנות ישירות לאפל או לגוגל בהתאם לחנות בה נרכש המנוי.</p>
            <p>4.7. ביטול המנוי לתקופת חיוב נתונה צריך להתבצע לפחות 24 שעות לפני סוף התקופה הנוכחית. ביטול שיתבצע פחות מ-24 שעות לפני סוף התקופה לא ימנע התחדשות אוטומטית של המנוי לתקופה הבאה (בהתאם למדיניות חנויות האפליקציות).</p>
            <p>4.8. השירות מהווה אספקת "מידע" כהגדרתו בחוק המחשבים, התשנ"ה-1995. בהתאם לתקנה 6(ב)(2) לתקנות הגנת הצרכן (ביטול עסקה), התשע"א-2010, זכות הביטול של 14 ימים שבסעיף 14ג לחוק הגנת הצרכן, התשמ"א-1981 (החזר מלא ללא נימוק תוך 14 ימים) — אינה חלה על שירות זה. עם זאת, המשתמש זכאי לבטל בכל עת את התחדשות המנוי לתקופות חיוב עתידיות, בכפוף לשאר הוראות חוק הגנת הצרכן.</p>
            <p>4.9. המפעיל רשאי לעדכן את תעריפי המנוי. הודעה מוקדמת על שינוי מחיר תישלח לפחות 30 ימים מראש לכתובת הדוא"ל הרשומה של המשתמש ו/או תוצג באפליקציה. שינויי מחיר יחולו רק על תקופות חיוב חדשות שתחילתן לאחר תום התקופה הנוכחית, ולא רטרואקטיבית.</p>
          </section>

          <section>
            <h2>5. קניין רוחני</h2>
            <p>5.1. כל זכויות הקניין הרוחני באפליקציה, לרבות עיצוב, טקסטים, סיכומים, תכנים קוליים, קוד תוכנה, לוגו, שם "Reado" ודמות תולי – שמורות למפעיל בלבד.</p>
            <p>5.2. אין להעתיק, לשכפל, להפיץ, לתרגם, למכור, להשכיר או לעשות כל שימוש מסחרי בתוכן האפליקציה ללא אישור מראש ובכתב מהמפעיל.</p>
          </section>

          <section>
            <h2>6. פרטיות</h2>
            <p>6.1. השימוש בשירות כפוף למדיניות הפרטיות של Reado, המפרטת את סוגי המידע הנאסף, השימושים בו, זכויות המשתמש ואופן יצירת קשר בנושאי פרטיות.</p>
            <p>6.2. מדיניות הפרטיות המלאה זמינה בתוך האפליקציה (הגדרות → מדיניות פרטיות) ומהווה חלק בלתי נפרד מתקנון זה.</p>
          </section>

          <section>
            <h2>7. הגבלת אחריות</h2>
            <p>7.1. השירות ניתן כמות שהוא (As-Is) והמפעיל אינו מתחייב שתוכן האפליקציה יתאים לצרכים מסוימים של כל משתמש.</p>
            <p>7.2. המפעיל אינו אחראי לטעויות, השמטות או נזקים מכל סוג שהוא שיגרמו כתוצאה מהסתמכות על התכנים.</p>
            <p>7.3. המפעיל לא יהיה אחראי לנזקים ישירים או עקיפים, לרבות הפסד הכנסה, תסכול או פגיעה אישית הנובעים מהשימוש באפליקציה או בהיעדר האפשרות להשתמש בה.</p>
            <p>7.4. בכל מקרה, אחריותו הכוללת של המפעיל כלפי המשתמש, מכל עילה שהיא — בין חוזית, נזיקית או אחרת — תוגבל לסכום ששילם המשתמש למפעיל בעבור השירות ב-12 החודשים שקדמו לעילת התביעה. הגבלה זו לא תחול במקום שבו לא ניתן להגביל אחריות לפי דין.</p>
          </section>

          <section>
            <h2>8. סיום שירות והשעיה</h2>
            <p>8.1. המפעיל רשאי לסיים או להשעות את השירות למשתמש, לפי שיקול דעתו, במקרה של הפרת התקנון או שימוש לרעה באפליקציה.</p>
            <p>8.2. המשתמש רשאי לסיים את השימוש בכל עת, אך לא יזכה להחזר עבור תקופה ששולמה מראש אלא אם נדרש על פי דין.</p>
          </section>

          <section>
            <h2>9. שינויים בתקנון</h2>
            <p>9.1. המפעיל רשאי לעדכן תקנון זה בכל עת. נוסח מעודכן יפורסם באפליקציה.</p>
            <p>9.2. שינויים מהותיים בתקנון (לרבות שינויים הנוגעים לתשלום, היקף השירות, זכויות המשתמש או שימוש במידע אישי) יודעו למשתמש מראש בדוא"ל ו/או בהודעה באפליקציה, לפחות 14 ימים לפני כניסתם לתוקף. שינויים מהותיים ייכנסו לתוקף רק לאחר התראה זו.</p>
            <p>9.3. שינויים שאינם מהותיים (תיקוני נוסח, הבהרות, עדכוני פרטי קשר וכד') יחולו מרגע פרסומם באפליקציה. המשך שימוש בשירות לאחר כניסת השינויים לתוקף ייחשב כהסכמה לנוסח המעודכן.</p>
          </section>

          <section>
            <h2>10. סמכות שיפוט</h2>
            <p>10.1. על תקנון זה יחולו דיני מדינת ישראל בלבד.</p>
            <p>10.2. כל סכסוך הנוגע לתקנון או לשימוש באפליקציה יתברר בבית המשפט המוסמך במחוז הצפון, בישראל.</p>
          </section>

          <section>
            <h2>11. יצירת קשר</h2>
            <p>לשאלות, בירורים או פניות בנושא פרטיות, ניתן ליצור קשר עם המפעיל באמצעות:</p>
            <ul>
              <li>מייל: reado.il.service@gmail.com</li>
              <li>טלפון: 053-5272518</li>
              <li>כתובת: קוממיות 9, מגדל העמק</li>
            </ul>
          </section>
        </div>
      </div>
    </section>
  );
}

export default TermsOfService;
